import { Setting } from './setting'
import { SettingQuery } from './setting-query'
import { SettingMutation } from './setting-mutation'

export const entities = [Setting]
export const resolvers = [SettingQuery, SettingMutation]
